import {NgModule} from '@angular/core';
import {ResponsiveColDirective} from './responsive-col.directive';
import {ResponsiveColsDirective} from './responsive-cols.directive';

@NgModule({
    declarations: [
        ResponsiveColsDirective,
        ResponsiveColDirective
    ],
    exports: [
        ResponsiveColsDirective,
        ResponsiveColDirective
    ]
})
export class ResponsiveColsModule {}
